import { Navigate, Outlet } from 'react-router-dom';
import { features, type FeatureName } from '../config/features';

export function FeatureRoute({ feature }: { feature: FeatureName }) {
  if (!features[feature]) return <Navigate to="/app/dashboard" replace />;
  return <Outlet />;
}

